// #ffa100

import { Component, OnInit } from "@angular/core";
import { FormBuilder,FormControl,FormGroup,Validators,} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { LoginService } from "../ApplicationServices/LoginService";
import { UserInfoStore } from "../shared/store/userInfo.store";

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
//  import { CustomValidators } from '../+Admin/custom-validators';
import { CustomValidators } from '../custom-validators';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {

  public ipAddress: string; 

  Dim_lon : Number;  Dim_lat : Number;
  IsSendCode : Number;

  fieldTextType: boolean;  fieldTextType1: boolean;  fieldTextType2: boolean;
  lpassword: string;  rpassword: string;

  closeResult: string;   moveForm: FormGroup;   moveModalReference: any;


  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$"; 
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";
  phoneNumber = "^(+d{1,3}[- ]?)?d{10}$";

  loginForm: FormGroup;
  loading = false;
  loading1 = false;loading2 = false;

  registerForm: FormGroup;
  alertmsg3: string;showAlert3: boolean;

  alertmsg: string;
  showAlert: boolean;
  showAlert1: boolean; showAlert2: boolean;

  error = "";
  submitted = false;
  registersubmitted = false;
  userID: any;
  fullName: any;
  orderMaster_Id: any;
  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private infoStore: UserInfoStore,
    private itemModifierService: ItemModifierService,
    private modalService: NgbModal,  private http: HttpClient,
  ) 
  {

    this.registerForm = this.createSignupForm();

  }


  
  createSignupForm(): FormGroup {
    return this.formBuilder.group(
      {

        userFullName: [
          null,
          Validators.compose([ 
          Validators.required ,         
          ])],

        phone: [
          null,
          Validators.compose([ 
          Validators.required ,         
          Validators.minLength(10) ])],

        email: [
          null,
          Validators.compose([Validators.email, Validators.required])
        ],
        password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator
      }
    );
  }

  IP_Address(){

    this.http.get('https://api.ipify.org?format=json').subscribe((data: any) => {
      this.ipAddress = data.ip;
      console.log('IP Address:', this.ipAddress);
    });
  }


  TraceDevice(){


    // let uniqueId = localStorage.getItem("uniqueDeviceId");
    // if (!uniqueId) {
    //     uniqueId = crypto.randomUUID(); // Generate a new UUID
    //     localStorage.setItem("uniqueDeviceId", uniqueId);
    // }

    this.loginService.getTraceDeviceData().subscribe((data) => {
      //this.bilService.printReportDayBookStatisticsData(  this.i1, this.i2 ,'EARNING','SUMMARY','CASH').subscribe((data) => {
      // this.PS2= data[0].PaidAmount.toString();
    
   
     });



  }


  ngOnInit() {  

     ///this.TraceDevice();
    ///this.IsSendCode = 0;

    this.registerForm.reset();
    //this.loggedIn = false;
    sessionStorage.clear();
    this.infoStore.setInfo({});
      // this.router.navigateByUrl("home");
     //this.totalCartItems = 0;
    // this.cartItems = [];
   // this.totalCartValue = 0;


    this.moveForm = new FormGroup({
      email1: new FormControl()

    });

    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });


    // this.registerForm = this.formBuilder.group({
    //   userFullName: new FormControl(),
    //   email: new FormControl(),
    //   //phone: new FormControl(),
    //   phone: ["", Validators.required],
    //   username: ["", Validators.required],
    //   password: ["", Validators.required],
    //   confirmPassword: ["", Validators.required],
    //   company: new FormControl(),
    //   branch: new FormControl(),
    // });

    
  }


  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
   }


   toggleFieldTextType1() {
    this.fieldTextType1 = !this.fieldTextType1;
   }

   toggleFieldTextType2() {
    this.fieldTextType2 = !this.fieldTextType2;
   }



  onSubmit() {

   /// this.IP_Address();   
    ///this.TraceDevice();

    // if( this.IsSendCode == 1 )
    // {
    //    return;
    // }
    // else
    // {

    // }

    if( this.loginForm.value.username=='' || this.loginForm.value.password=='' ){

      this.alertmsg = "Access denied , mandatory fields must be filled up with proper data !";
      this.showAlert1 = true;
      setTimeout(() => {
        this.showAlert1 = false;
      }, 5000);
     // return;

    }
    else{

      this.submitted = true;
      // stop here if form is invalid
      if (this.loginForm.invalid) {
          return;
      }

      this.loading = true;

      const formData = new FormData();
      var obj = {

           // "CompId": this.loginForm.value.company,
          //"BranchId": this.loginForm.value.branch,

          "CompId": 1,
          "BranchId": 1,
          "UserName": this.loginForm.value.username,
          "UserPassword": this.loginForm.value.password,


      };
      formData.append('params', JSON.stringify(obj));
      this.loginService.login(obj)

      //)
      .subscribe((data: any) => {
          if (data.length > 0) {
            this.userID = data[0].UserId;
            this.fullName = data[0].UserFullName;
            /// this.orderMaster_Id = data[0].OrderMaster_Id;
            this.orderMaster_Id = 1;
            this.infoStore.setInfo({
              UserId: data[0].UserId,
              UserFullName: data[0].UserFullName,
              //UserNames: data[0].UserName,

             /// OrderMaster_Id: data[0].OrderMaster_Id,
             OrderMaster_Id: 1,
            });

             // this.callApi();
            //this.loading1 = false;

              if (true) {
                  navigator.geolocation.getCurrentPosition((position) => {
                      this.Dim_lon = position.coords.longitude;
                      this.Dim_lat = position.coords.latitude;
                      this.callApi();

                  });
                 // this.callApi();

              } else {
                  console.log("No support for geolocation")
                  this.error = "No support for geolocation";
                  this.loading = false;
                  this.callApi();
              }

          } else {
              this.error = "Invalid Credentials";
              this.loading = false;

              this.alertmsg = "Invalid Credentials";
              this.showAlert1 = true;
              setTimeout(() => {
                this.showAlert1 = false;
              }, 5000);

          }
      },
          error => {
              this.error = error;
              this.alertmsg = "Invalid Credentials";
              this.showAlert1 = true;
              setTimeout(() => {
                this.showAlert1 = false;
              }, 5000);
              this.loading = false;
      });



    }



    // if (this.loginForm.invalid) {
    //     return;
    // }

    // this.loading = true;
       //    this.loginService.login(
     //         this.loginForm.value.username,
    //         this.loginForm.value.password,
   //         this.loginForm.value.company,
  //         this.loginForm.value.branch,



}



  // onSubmit() {


  //   if( this.loginForm.value.username=='' || this.loginForm.value.password=='' ){

  //     this.alertmsg = "Access denied , mandatory fields must be filled up !";
  //     this.showAlert1 = true;
  //     setTimeout(() => {
  //       this.showAlert1 = false;
  //     }, 3000);


  //   }
  //   else{


  //     this.loginService
  //     .login(this.loginForm.value.username, this.loginForm.value.password, 1, 1)
  //     .subscribe(
  //       (data: any) => {
  //         if (data.length > 0) {
  //           this.userID = data[0].UserId;
  //           this.fullName = data[0].UserFullName;
  //           this.orderMaster_Id = data[0].OrderMaster_Id;
  //           this.infoStore.setInfo({
  //             UserId: data[0].UserId,
  //             UserFullName: data[0].UserFullName,
  //             OrderMaster_Id: data[0].OrderMaster_Id,
  //           });
  //           this.callApi();


  //         } else {


  //          this.alertmsg = "Invalid Credentials";

  //          this.showAlert1 = true;
  //          setTimeout(() => {
  //            this.showAlert1 = false;
  //          }, 3000);


  //         }



  //       }

  //     );


  //   }

  // }



  // convenience getter for easy access to form fields




  get f() {
    return this.loginForm.controls;
  }

  // convenience getter for easy access to form fields
  get r() {
    return this.registerForm.controls;
  }


  onRegister() {
    //this.registersubmitted = true;

    // if (this.registerForm.invalid) {
    //   return;
    // }

    if( this.registerForm.value.userFullName=='' || this.registerForm.value.phone==''  || this.registerForm.value.email=='' || this.registerForm.value.password=='' || this.registerForm.value.confirmPassword=='' ){

      this.alertmsg = "Access denied , mandatory fields must be filled up !";
      this.showAlert2 = true;
      setTimeout(() => {
        this.showAlert2 = false;
      }, 3000);
     // return;

    }
    else if( this.registerForm.value.password != this.registerForm.value.confirmPassword )
    {

      this.alertmsg = "Access denied , Password & Confirm Password is mismatched !";
      this.showAlert2 = true;
      setTimeout(() => {
        this.showAlert2 = false;
      }, 3000);
      //return;

    }
    else
    {


      const formData = new FormData();
      var obj = {
        UserRoleId: 9, // UNAPPROVED USER
        CompId: 1,
        BranchId: 1,
        UserFullName: this.registerForm.value.userFullName,
        UserName: this.registerForm.value.email.trim(),
        UserPassword: this.registerForm.value.password,
        UserMail: this.registerForm.value.email.trim(),
        UserContactNO: this.registerForm.value.phone,
        OperationType: "INSERT",
        Notes: "MOB APP",

      };
      formData.append("params", JSON.stringify(obj));
      this.loginService.register(obj).subscribe((event: any) => {
        if (event && event.length > 0) {
          console.log(event);

          this.registerForm.reset();
          this.alertmsg = event[0].OperationStatus;
          this.showAlert2 = true;
          setTimeout(() => {
            this.showAlert2 = false;
          }, 3000);


        }
      });


     

    }


  }

  callApi() {
    sessionStorage.setItem("UID", this.userID);
    sessionStorage.setItem("LoggedInId", this.userID);
    sessionStorage.setItem("Name", this.fullName);
    ///sessionStorage.setItem("OrderMaster_Id", this.orderMaster_Id);
    sessionStorage.setItem("OrderMaster_Id", "1");
    sessionStorage.setItem("ProceedPay_Id", "0");

    sessionStorage.setItem("UserName", this.loginForm.value.username );

    sessionStorage.setItem("DLON", this.Dim_lon.toString());
    sessionStorage.setItem("DLAT", this.Dim_lat.toString());

    this.getCartInfo();
    this.router.navigate(["home"]);

  }


  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }




  openMoveModal1(content) {
    this.moveForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
   }
  }

  onMoveInfoSubmit(){

    ///if( this.moveForm.value.email1=='' ){
      if( this.loginForm.value.username=='' ){

      this.alertmsg = "Enter Username i.e. Registered E-mail !!";
      this.showAlert1 = true;
      setTimeout(() => {
        this.showAlert1 = false;
      }, 3000);
     return;

    }


    this.loginService.getPasswordReset(this.loginForm.value.username)
      .subscribe((event: any) => {

        //this.IsSendCode = 1;
        if (event.length > 0) {

        }
      });

      ///this.moveModalReference.close();

     ///  this.alertmsg3 = "New Password will be send shortly to your registered E-mail !";
     this.alertmsg = "Code will be send shortly to your official E-mail !";
     this.showAlert1 = true;
     setTimeout(() => {
     this.showAlert1 = false;
     }, 5000);


  }



}
